module.exports = __webpack_public_path__ + "img/img24.4f15782d.svg";